import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import Table from "./ZoneTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faPlus, faUndo } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import { Redirect } from "react-router-dom";
import Select from "react-select";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class DemographicDetail extends React.Component {
  state = {
    countries: [],
    redirect: false,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: '',
    states: [],
    zones: [],
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleChangeZone = (newValue, actionMeta) => {
    this.zoneId = newValue.value;

    console.groupEnd();
  };

  handleChangeState = (newValue, actionMeta) => {
    //console.log(newValue);
    this.stateIds = [];
    for (let i = 0; i < newValue.length; i++) {
      this.stateIds.push(newValue[i].value);
    }
    console.groupEnd();
  };

  constructor(props) {
    super(props);
  }
  handleChangeCountry = (newValue, actionMeta) => {
    console.log(newValue, "jj");
    this.countryId = newValue.value;
    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + this.countryId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-zones?country_id=` + this.countryId,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          zones: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false, });
  };

  redirectToClose = () => {
    this.setState({
      popupalertMessage: false,
      popupMessageContent: '',
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/demographic-detail" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Masters</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>Unit Directory</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Demographic Detail</a>
              </li>
            </ul>
          </div>
        </div>


        <Formik
          initialValues={{
            countryId: "",
            circleName: "",
            zoneId: "",
            stateIds: "",
          }}
          onSubmit={(values, actions) => {
            values.zoneId = this.zoneId;
            values.countryId = this.countryId;
            values.stateIds = this.stateIds;
            // alert(JSON.stringify(values, null, 2));

            console.log(values);
            var self = this;
            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/unit-detail/create-circle`,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                // alert("Data Saved Successfully");
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: 'Data Saved Successfully'
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off" >
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Country <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              name="countryId"
                              onInputChange={this.handleChange}
                              onChange={this.handleChangeCountry}
                              options={this.state.countries.map((item) => ({
                                label: item.country_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="countryId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Zone
                          </label>
                          <div className="col-sm-7">
                            <CreatableSelect
                              name="zoneId"
                              onInputChange={this.handleChange}
                              onChange={this.handleChangeZone}
                              options={this.state.zones.map((item) => ({
                                label: item.zone_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="zoneId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Circle
                          </label>
                          <div className="col-sm-7">
                            <Field as="select" name="circleName">
                              <option value="" label="Select" defaultValue />
                              <option value="North 1" label="North 1" />
                              <option value="North 2" label="North 2" />
                              <option value="South 1" label="South 1" />
                              <option value="South 2" label="South 2" />
                              <option value="East 1" label="East 1" />
                              <option value="East 2" label="East 2" />
                              <option value="West 1" label="West 1" />
                              <option value="West 2" label="West 2" />
                              <option value="Central 1" label="Central 1" />
                              <option value="Central 2" label="Central 2" />
                            </Field>
                            <ErrorMessage
                              name="circleName"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            State <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              isMulti
                              name="stateIds"
                              onInputChange={this.handleChange}
                              onChange={this.handleChangeState}
                              options={this.state.states.map((item) => ({
                                label: item.state_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="stateIds"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            District <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              isMulti
                              name="stateIds"
                              onInputChange={this.handleChange}
                              onChange={this.handleChangeState}
                              options={this.state.states.map((item) => ({
                                label: item.state_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="stateIds"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 offset-lg-6">
                      <div className="btnContainer">
                        <div>
                          <button type="submit" disabled={isSubmitting}>
                            Add
                          </button>
                          <button type="submit" disabled={isSubmitting}>
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
        <Table />
      </div>
    );
  }
}

export default DemographicDetail;
